<div class="cdk-virtual-scroll-data-source-example">
  <cdk-virtual-scroll-viewport
    orientation="horizontal"
    [itemSize]="itemSize"
    style="height: 150px"
    class="example-viewport"
    >
    <div
      *cdkVirtualFor="let item of items"
      class="flex flex-col justify-center cursor-pointer w-96 h-full p-1"
      (click)="detail.emit(item)"
      >
      <div class="relative">
        <img [src]="item.thumb" class="rounded relative self-center" />
        @if (activeId === item.id) {
          <div class="rounded overlay bg-primary"></div>
        }
      </div>
    </div>
  </cdk-virtual-scroll-viewport>
</div>
